import { Directive, HostBinding, HostListener, Input } from '@angular/core';


@Directive({
    selector: '[InchValidate]'
})
export class InchValidateDirective {
    private srcAttrValue = '';
    @Input('value') sourceValue;
    @HostListener('blur')
    valueRefresh() {
        const regex = /^([1-2]?[0-9]{1,3})\'([0-9]|[0-1]{2})\"$/gm;
        let temp = [];
        if ((temp = regex.exec(this.sourceValue))) {
            this.srcAttrValue = temp[0];
        } else {
            this.srcAttrValue = '';
        }

    }

    @HostBinding('attr.value') srcAttr = this.srcAttrValue;
    constructor() { }
}
